module.exports = __webpack_public_path__ + "img/03ddf9ef-b930-4ac2-9804-bb0494780f17.d2a7e993.webp";